import { useEffect, useState } from "react";
import { requestGetEnvironmentList } from "services/acadReinforce/relatedToAcadReinforce";
import { INIT_FORM } from "../constants";

const useEnvironmentList = ({
    loadingRequest,
    form
}) => {
    //#region States
    const [environmentList, setEnvironmentList] = useState([]);
    const [triggerFillRequest, setTriggerFillRequest] = useState(false);
    //#endregion
    //#region Effects
    useEffect(() => {
        if (!form.isLoaded) return;
        fillEnvironmentList();
    }, [form.isLoaded]);
    useEffect(() => {
        if (!triggerFillRequest) return;
        fillEnvironmentList();
        setTriggerFillRequest(false);
    }, [triggerFillRequest]);
    useEffect(() => {
        if (!environmentList.some(environment => environment.id === form.value.environment.id))
            form.change("environment", { ...INIT_FORM.environment });
    }, [environmentList]);
    //#endregion
    //#region Functions
    const fillEnvironmentList = async () => {
        const {
            campusDetailId, environmentTypeId,
            quantityVacancy, date, timeStart, timeEnd
        } = form.value;
        if (timeEnd <= timeStart || !(Number(quantityVacancy) > 0)) return;
        loadingRequest.show("Cargando ambientes...");
        const data = await requestGetEnvironmentList({
            campusId: campusDetailId, environmentTypeId,
            quantityVacancy, date, time: { 
                start: timeStart, end: timeEnd 
            }
        });
        setEnvironmentList(data);
        loadingRequest.hide("Cargando ambientes...");
    }
    //#endregion
    return {
        value: environmentList,
        fill: () => setTriggerFillRequest(true)
    };
}

export default useEnvironmentList;